export const APP_ID = process.env.REACT_APP_LEANPLUM_APP_ID;
export const ACCESS_KEY = process.env.REACT_APP_LEANPLUM_API_KEY;
